import { logger } from './sentry'

export const captureError = (name: `${string}_error`, params: any) => {
  // Skip Abort errors, which are common in development
  if (params?.error?.name === 'AbortError') return
  logger.error(name, params)
}
